module.exports = __webpack_public_path__ + "img/IMG_8939.3b4523ff.jpg";